// Some profiles were saved with a form hint as the real value — «Компаниянын
// атын жазсаңыз болот.» in «Агенттиктин аталышы» and «Сүрөттөмө». It then
// shows up on the public agency page as if it were the agency's name. Such
// text is treated as empty: hidden everywhere and cleared on the next save.

const HINT_PATTERNS = [
  /жазсаңыз\s+болот\.?$/i,
  /(жазыңыз|киргизиңиз|көрсөтүңүз)\.?$/i,
  /^(введите|укажите|напишите|можно указать|вы можете указать)\b/i,
  /^(enter|type|write)\s+(your|the|a)\b/i,
];

const PROFILE_TEXT_FIELDS = ["company_name", "company_description", "company_address", "company_time"] as const;

/** A short value that reads like an input hint, not real content. */
export function isHintText(value: unknown): boolean {
  const v = String(value ?? "").trim();
  return v.length > 0 && v.length <= 80 && HINT_PATTERNS.some((re) => re.test(v));
}

/** Copy of a user/profile with hint-like texts blanked. */
export function cleanProfileText<T>(user: T): T {
  if (!user || typeof user !== "object") return user;
  const out: any = { ...(user as any) };
  for (const key of PROFILE_TEXT_FIELDS) {
    if (isHintText(out[key])) out[key] = "";
  }
  return out;
}
